/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_TitleInputs */

const vi_care_log_title = /** @type {(inputs: Care_Log_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký chăm sóc`)
};

/**

* @param {Care_Log_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_title = /** @type {((inputs?: Care_Log_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_title(inputs)
});